import { render, staticRenderFns } from "./navButtons.vue?vue&type=template&id=7c629f4b&scoped=true&"
import script from "./navButtons.vue?vue&type=script&lang=js&"
export * from "./navButtons.vue?vue&type=script&lang=js&"
import style0 from "./navButtons.vue?vue&type=style&index=0&id=7c629f4b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c629f4b",
  null
  
)

export default component.exports